<style>
.el-table .warning-row {
  background: oldlace;
}
.el-table .success-row {
  background: #f0f9eb;
}
a {
  color: #333333;
  text-decoration: none;
}
a:hover {
  color: #1890ff;
  text-decoration: none;
}
.hdNews {
  padding: 12px 24px;
  margin-bottom: 10px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}
.content_body li {
  line-height: 28px;
  padding: 0 0 0 10px;
}
.clear {
  clear: both;
}
</style>
<template>
  <div>
    <HeaderView></HeaderView>
    <NavigateView></NavigateView>
    <BannerView></BannerView>
    <div v-bind:style="{minHeight: height+'px'}" style="width: 980px; margin: 0 auto;">
      <template>
        <div class="content_body">
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item style="padding-top: 8px;">集中议价</el-breadcrumb-item>
            <el-breadcrumb-item style="padding-top: 8px;">关注问题</el-breadcrumb-item>
            <!-- <el-button key="点我留言" size="mini" style="float: right;" @click="question">点我留言</el-button> -->
          </el-breadcrumb>
          <el-divider content-position="left"></el-divider>
          <div v-if="showLink">
            <div>&emsp;&emsp;</div>
            <div>&emsp;&emsp;<el-link type="primary" @click="changeContent(1)"  style="font-size: 14px; margin-bottom: 10px;">1、2026年药品集中议价采购工作相关问题</el-link></div>
          </div>
          <div v-if="showContent[1]">
            <div style="float: right;">
              <el-link icon="el-icon-close" @click="changeContent(0)">关闭</el-link>
            </div>
            <p style="text-align: center;font-size: 14px;font-family: 微软雅黑;">
              <span style="font-size: 24px;font-family: 微软雅黑;">2026年药品集中议价采购工作相关问题</span>
            </p>
            <p style="text-align: justify;font-size: 14px;font-family: 微软雅黑;">
              &nbsp;
            </p>
            <p style="font-size: 14px;font-family: 微软雅黑;line-height: 21px">
              <span style="line-height: 24px; font-family: 微软雅黑; font-size: 14px;">自采购联盟药品集中议价采购公告发布以来，联盟工作组接到大量企业来电、来访咨询，针对来电来访的共性问题，反馈如下：</span>
            </p>
            <p style="text-align: justify;font-size: 14px;font-family: 微软雅黑;line-height: 21px">
              <strong><span style="font-size: 14px;line-height: 24px;font-family: 微软雅黑">1、企业问：未在上海阳光平台挂网的药品是否可参与本次申报？</span></strong>
            </p>
            <p style="font-size: 14px;font-family: 微软雅黑;text-indent: 32px;line-height: 21px">
              <span style="line-height: 24px; font-size: 14px; font-family: 微软雅黑;">答：不可以。应是已在本市阳光平台挂网、医疗机构可正常采购的药品。</span>
            </p>
            <p style="text-align: justify;font-size: 14px;font-family: 微软雅黑;line-height: 21px">
              <strong><span style="font-size: 14px;line-height: 24px;font-family: 微软雅黑">2、企业问：申报价格不高于上海阳光平台药品挂网价格是否即可中选？</span></strong>
            </p>
            <p style="text-align: justify;font-size: 14px;font-family: 微软雅黑;text-indent: 32px;line-height: 21px">
              <span style="line-height: 24px; font-size: 14px; font-family: 微软雅黑;">答：按本市药品挂网管理相关规定，医疗机构药品实际采购价格不得高于本市药品挂网价格。因此，申报价格不高于挂网价格视为有效申报品种。</span>
            </p>
            <p style="font-size: 14px;font-family: 微软雅黑;text-indent: 32px;line-height: 21px">
              <span style="line-height: 24px; font-size: 14px; font-family: 微软雅黑;">对有效的申报品种，采购联盟议价工作组将以临床需求为导向，按照医保药品分类规则，遵循价差优先原则开展集中评价议价，据此确定中选结果。</span>
            </p>
            <p style="text-align: justify;font-size: 14px;font-family: 微软雅黑;line-height: 21px">
              <strong><span style="font-size: 14px;line-height: 24px;font-family: 微软雅黑">3、企业问：什么是联盟药品集中议价？</span></strong>
            </p>
            <p style="text-align: justify;font-size: 14px;font-family: 微软雅黑;text-indent: 32px;line-height: 21px">
              <span style="line-height: 24px; font-size: 14px; font-family: 微软雅黑;">答：根据药品集中议价采购联盟议事规则，由联盟专家组、工作组、议价组实施药品集中议价，产生联盟医疗机构药品采购推荐目录，联盟医疗机构优先在目录内进行采购。
              联盟药品集中议价是通过订单合并，提高议价能力的有效措施。主要从两方面着手开展：一是按医保药品分类，在相同药品分类下，根据企业报价响应情况，进行综合评审遴选；二是强化“采购联盟—团体会员单位”联动，提高联盟医疗机构在目录内的使用集中度。
              </span>
            </p>
            <p style="text-align: justify;font-size: 14px;font-family: 微软雅黑;line-height: 21px">
              <strong><span style="font-size: 14px;line-height: 24px;font-family: 微软雅黑">4、企业问：联盟中选药品价格与“全国药品挂网价格一览表”的关系？</span></strong>
            </p>
            <p style="text-align: justify;font-size: 14px;font-family: 微软雅黑;text-indent: 32px;line-height: 21px">
              <span style="line-height: 24px; font-size: 14px; font-family: 微软雅黑;">答：本市药品挂网操作办法规定，医疗机构实际采购价格低于挂网价格的，按实际采购价在本市平台进行登记。联盟药品集中议价产生的药品采购价在本市阳光平台集中议价子模块进行登记和维护，仅限联盟医疗机构可见和使用，不改变药品在阳光平台的挂网价。</span>
            </p>
            <p style="text-align: justify;font-size: 14px;font-family: 微软雅黑;line-height: 21px">
              <strong><span style="font-size: 14px;line-height: 24px;font-family: 微软雅黑">5、企业问：本次未参与申报或未降价的药品是否有动态议价机会？</span></strong>
            </p>
            <p style="text-align: justify;font-size: 14px;font-family: 微软雅黑;text-indent: 32px;line-height: 21px">
              <span style="line-height: 24px; font-size: 14px; font-family: 微软雅黑;">答：联盟采购目录是通过本轮次药品集中议价采购公告和企业响应实现。动态议价主要适用于国家组织药品集中带量采购或上海阳光平台药品价格调整等情形涉及的药品。</span>
            </p>
            <p style="text-align: justify;font-size: 14px;font-family: 微软雅黑;text-indent: 32px;line-height: 21px">
              <span style="line-height: 24px; font-size: 14px; font-family: 微软雅黑;"></span>
            </p>
            <p><br /></p>
          </div>
        </div>

      </template>
    </div>

    <FooterView></FooterView>
  </div>

</template>
<script>
export default {
  name: 'concernedAbout',
  data () {
    return {
      active: 0,
      height: 0,
      operate: false,
      captchaUrl: '',
      display: false,
      showLink: false,
      showContent: [false, false, false, false, false, false, false, false, false, false],
      dialogVisible: false,
      dialogApplyVisible: false,
      submitButtonLoading: false,
      form: { ctgId: '', title: '', content: '', captcha: '', positions: '', phone: '', email: '', participants: '', },

      queryform: {
        data: [], total: 0, pageNo: 1, pageSize: 10, pageSizes: [10, 20, 50, 100], fn: 'page',
      },
      categoryList: [],
      liBackgroundImg: process.env.VUE_APP_API_URL + 'r/cms/www/default/img/index/li_bg.jpg',
    };
  },
  mounted () {
    if(!sessionStorage[this.$route.path]){
        window.location.href = process.env.VUE_APP_API_URL;
      }
    //动态设置内容高度 让footer始终居底   header+footer的高度是100
    this.height = document.documentElement.clientHeight - 350;
    //监听浏览器窗口变化　
    window.onresize = () => { this.height = document.documentElement.clientHeight - 350 }
  },
  created () {
    this.initView()
  },
  watch: {},
  methods: {
    initView () {
      setTimeout(() => {
        this.submitButtonLoading = true;
        new Promise((resolve, reject) => {
          return this.$api.memberApi.getDeclareResult({ stype: 'DECLARE' }).then(data => {
            if (!data) {
              this.goLogin();
            } else {
              if (200 === data.status) {
                if (200 === data.data.code) {
                  this.showLink = true
                } else if (403 === 200) {
                  this.showLink = false
                } else {
                  this.showLink = false
                }
              } else {
                this.goLogin();
              }
            }
            resolve(true);
          })
        }).catch(err => {
          this.goLogin();
        })
      })
    },
    handleClick (tab, event) {
      if (this[event]) {
        this[event].call(this, tab);
      }
    },
    changeContent (idx) {
      if (idx) {
        this.showLink = false;
        this.showContent.forEach((w, index) => {
          if (index === idx) {
            this.showContent[index] = true;
          } else {
            this.showContent[index] = false;
          }
        })
      } else {
        this.showContent.forEach((w, index) => {
          this.showContent[index] = false;
        })
        this.showLink = true;
      }
      console.info(this.showContent)
    },
    getRowKeys (row) {
      return row.id
    },
    toDateString: function (time, format) {
      let date = new Date(time || new Date())
        , ymd = [this.digit(date.getFullYear(), 4), this.digit(date.getMonth() + 1), this.digit(date.getDate())]
        , hms = [this.digit(date.getHours()), this.digit(date.getMinutes()), this.digit(date.getSeconds())];
      format = format || 'yyyy-MM-dd HH:mm:ss';
      return format.replace(/yyyy/g, ymd[0]).replace(/MM/g, ymd[1]).replace(/dd/g, ymd[2]).replace(/HH/g, hms[0]).replace(/mm/g, hms[1]).replace(/ss/g, hms[2]);
    },
    clearValidate (formName) {
      this.$refs[formName].clearValidate();
    },
    changeCaptcha: function () {
      this.captchaUrl = this.getCaptchaUrl();
    },
    getCaptchaUrl: function () {
      this.form.captcha = '';
      return process.env.VUE_APP_API_URL + 'captcha.svl?d=' + new Date().getTime()
    },
    goLogin () {
      this.$message({ message: '登录过期，请重新登录账户！', offset: 200, type: 'error' });
      setTimeout(() => {
        this.submitButtonLoading = false;
        window.location.href = process.env.VUE_APP_API_URL;
      }, 2000)
    }
  }
}
</script>
<style>
.el-dialog__footer {
  text-align: center;
}
.el-divider-horizontal {
  display: block;
  height: 1px;
  width: 100%;
  margin: 12px 0;
}
.upload-left {
  text-align: left;
}

.register-wrapper-div {
  padding-top: 10px;
  width: 750px;
  margin: 0 auto;
  background-color: #f8f8f8;
}
.el-dialog__body {
  padding: 10px 20px;
}
.el-radio {
  margin-right: 0;
}
.el-checkbox {
  margin-right: 5px;
}
.el-radio--mini.is-bordered {
  margin: 2px 0;
}
.el-divider--horizontal {
  margin: 10px 0;
}
.el-collapse-item__content {
  padding-bottom: 10px;
}
.el-alert--info.is-light {
  width: auto;
  height: 65%;
  margin-right: 15px;
}
.el-tag--plain {
  width: 130px;
  text-align: center;
  border: 0px solid #fff;
}
.radio-br {
  width: 75%;
}
.radio-auto {
  float: left;
  margin-right: 10px;
}
.assess-score {
  margin-right: 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/Member/ConcernedAbout.vue